import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { NotaCreditoFactura } from "./informacionnotadecredito";

type Entity = models.FacturaDto;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    soloLectura: boolean;
}

/**
* Componente auxiliar para mostrar la parte de notas de credito de las facturas
*/
export class AuxiliarNotaDeCreditoNoRx extends React.PureComponent<Props> {
    getField = kea.formfields(() => this.props);
    value = (props: Props) => props.value;

    render() {
        var { value, soloLectura } = this.props;
        const NotaCredito = this.getField(NotaCreditoFactura);

        return (
            <div>
                <NotaCredito field="InformacionDeNotaDeCredito" soloLectura={soloLectura} dto={value} />
            </div>
        );
    }
}

export const AuxiliarNotaDeCredito = componentToRx(AuxiliarNotaDeCreditoNoRx);
    


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/edit/componentes/auxiliarnotadecredito.tsx